import * as Toolkit from '../../../toolkit/index';
import * as Utils from '../../../utils/util';


interface CreateGoodsImgDomParams {
    imgMap: FreeObjMap,
    direction: number,
    rotate: number,
    width: number,
    height: number,
    wareBoxedImgMap?: FreeObjMap,
    boxSpec?: string
}

/**
 * 创建商品图片dom对象
 *
 * 返回结构:
 * <img alt="图片加载中..." src="..."  data-good="1">
 */
function createGoodsImgUI(params: CreateGoodsImgDomParams): JQuery<HTMLElement> {
    let img: HTMLElement = document.createElement('img');
    let $result: JQuery<HTMLElement> = $(img);
    let deg: number = 90 * params.rotate;
    let emptyUrl: string = '//img.dmallcdn.com/dshop/202012/602ed622-7700-4c2b-a2ed-9ce47d93a4d3';
    let transform: FreeObjMap = {
        width: params.width,
        height: params.height
    };
    let imgUrl: string = '';
    let imgHost: string = Utils.getImgHost(false)

    if ([1, 3].includes(params.rotate)) {
        transform.width = params.height;
        transform.height = params.width;
    }

    if (params.boxSpec) {
        if (!params.wareBoxedImgMap[params.boxSpec]
            || !params.wareBoxedImgMap[params.boxSpec][params.direction]) {
            imgUrl = emptyUrl;
        }
        else {
            imgUrl = `${imgHost}${params.wareBoxedImgMap[params.boxSpec][params.direction]}`;
        }
    }
    else {
        if (!params.imgMap[params.direction]) {
            imgUrl = emptyUrl;
        }
        else {
            imgUrl = `${imgHost}${params.imgMap[params.direction]}`;
        }
    }

    $result.css({
       position: 'absolute',
       width: Toolkit.cmToPx(transform.width),
       height: Toolkit.cmToPx(transform.height),
       transform: 'rotate(' + deg + 'deg) translateY(-50%) translateX(-50%)',
       transformOrigin: '0 0',
       top: ' 50%',
       left: '50%'
   })
   .addClass('goods-img')
   // .attr('src', '//img.dmallcdn.com/dshop/202012/602ed622-7700-4c2b-a2ed-9ce47d93a4d3')
   .attr('src', imgUrl)
   .attr('data-good', '1')

    return $result;
}

export default createGoodsImgUI;
